<template>
  <BCard
      bg-variant="light"
      title="Dispenser Guide Upload"
      subtitle="Submit a new Dispenser Guide"
      subtitle-text-variant="muted"
  >
    <BCardText>
      <BRow>
        <BCol cols="3">
          <BFormGroup>
            <select class="mt-3 form-select" v-model="selectedState" aria-label="PMP" required>
              <option disabled value="">Select PMP</option>
              <option v-for="option in stateOptions" :key="option.value" :value="option.value">
                {{ option.text }}
              </option>
            </select>
          </BFormGroup>
        </BCol>
        <BCol cols="3">
          <BFormGroup
            :invalid-feedback="invalidFeedback"
            :valid-feedback="validFeedback"
            :state="success"
          >
            <div class="mb-2 mt-3">
              <div class="input-group">
                <input
                  type="file"
                  class="file-field form-control"
                  id="fileInput"
                  data-bfi-disabled
                  aria-label="Dispenser Guide File"
                  @change="handleFileChange"
                />
              </div>
            </div>
          </BFormGroup>
        </BCol>
      </BRow>
    </BCardText>
    <template v-slot:footer>
      <BButton
        variant="primary"
        :disabled="submitDisabled"
        data-bs-toggle="modal"
        data-bs-target="#uploadConfirmationModal"
        @click="uploadClicked()"
      >
          <span v-if="submitting">
            <BSpinner small></BSpinner>
            Uploading
          </span>
        <span v-else>
            Upload
          </span>
      </BButton>

      <div class="modal fade" id="uploadConfirmationModal" tabindex="-1" aria-labelledby="uploadConfirmationModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="uploadConfirmationModalLabel">Upload Dispenser Guide</h5>
              <button type="button" class="custom-close" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              You are about to upload this Dispenser Guide. Is this correct?
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Change</button>
              <button type="button" class="btn btn-danger" data-bs-dismiss="modal" @click="uploadFile">Upload</button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </BCard>
</template>

<script>
import axios from "axios"
import {
  BCard, BCardText, BRow, BCol, BFormGroup, BSpinner, BButton
} from "bootstrap-vue-next"

export default {
  data(){
    return {
      file: null,
      invalidFeedback: "",
      validFeedback: "",
      success: null,
      submitting: false,
      selectedState: "",
      stateOptions: []
    }
  },
  components: {
    BCard, BCardText, BRow, BCol, BFormGroup, BSpinner, BButton
  },
  computed: {
    submitDisabled() {
      return !this.file || !this.selectedState || this.submitting;
    },
    lookupStatesPath() {
      return `/pmps/admin`
    }
  },
  methods: {
    clear() {
      this.invalidFeedback = "";
      this.validFeedback = "";
      this.success = null;
    },
    handleFileChange(event) {
      this.file = event.target.files[0];
    },
    uploadClicked() {
      this.clear();
    },
    uploadFile(){
      this.submitting = true;

      let vm = this;

      let formData = new FormData();
      formData.append("pmp_id", this.selectedState);
      formData.append("dispenser_guide_file", this.file);

      axios.post( "/dispenser_guides",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      ).then(function(response){
        vm.success = true;
        vm.validFeedback = "Dispenser Guide successfully uploaded."
      })
      .then(function (response) {
        window.location.href = "/dispenser_guides";
      })
      .catch(function (error) {
        vm.invalidFeedback = error.response.data["error"];
        vm.success = false;
      })
      .then(function(){
        vm.submitting = false;
      });
    },
    getStateOptions() {
      let vm = this;

      axios.get(
        vm.lookupStatesPath
      ).then(function (response) {
        response.data.forEach(
          state => vm.stateOptions.push(
            { value: state["id"], text: state["name"] }
          )
        );

        vm.errorMessages = [];
      })
      .catch(function (error) {
        vm.errorMessages = [vm.notFoundError];
      });
    }
  },
  mounted() {
    this.getStateOptions()
  }
}
</script>
